import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mq } from 'responsive';

export const SideBarContainer = styled.div<{ isActive: boolean }>(
  ({ theme, isActive }) => css`
    background: ${theme.WHITE};
    border-right: 1px solid ${theme.GREY_3};
    width: 0;
    height: 100%;
    padding-top: 18px;
    overflow: hidden;
    -webkit-transition: all 0.4s ease 0s;
    -moz-transition: all 0.4s ease 0s;
    -o-transition: all 0.4s ease 0s;
    transition: all 0.4s ease 0s;

    & > * {
      opacity: 0;
      -webkit-transition: all 0.4s ease 0s;
      -moz-transition: all 0.4s ease 0s;
      -o-transition: all 0.4s ease 0s;
      transition: all 0.4s ease 0s;
    }

    ${isActive &&
    css`
      width: 298px;
      overflow-y: auto;
      padding-bottom: 80px;
      & > * {
        opacity: 1;
      }
    `};

    ${mq.mobile} {
      height: auto;
      position: fixed;
      top: 70px;
      bottom: 0;
      left: 0;
      /* Keep below the shared Modal (z-index 999, Modal.styles.ts): modals opened
         from the filters, e.g. the version selection, must cover this overlay. */
      z-index: 900;
      border-right: 0;
      overscroll-behavior: contain;
      transition: none;
      ${isActive ? 'width: 100%; padding-bottom: 96px;' : 'width: 0; padding: 0;'}
    }

    /* hide scrollbar */
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none; /* for Chrome, Safari, and Opera */
    }
  `
);

export const FiltersMain = styled.div`
  border-bottom: 1px solid ${({ theme }): string => theme.GREY_3};
`;

export const SideBarFooter = styled.div`
  display: none;

  ${mq.mobile} {
    display: flex;
    justify-content: center;
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 901;
    padding: 12px 16px;
    background: ${({ theme }): string => theme.WHITE};
    border-top: 1px solid ${({ theme }): string => theme.GREY_3};

    & > button {
      width: 100%;
      min-height: 44px;
    }
  }
`;
